var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChartdonut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 256 256"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.39 24.06A16 16 0 00120 40v40.67a15.86 15.86 0 0013.25 15.76A32 32 0 1196 129.68c-.41-8.22 1.27-15 5-20.26a15.86 15.86 0 00-1.69-20.47L71.69 60.68a16 16 0 00-23.63 1.1A103.6 103.6 0 0055 202.05 103.24 103.24 0 00128 232h1.49A104.3 104.3 0 00232 129.48c.75-54.3-40.81-100.6-94.61-105.42zM60.32 71.94l27.61 28.19v.06A43.29 43.29 0 0080.44 120H40.36a87.13 87.13 0 0119.96-48.06zM40.37 136h40.3A48 48 0 00120 175.34v40.3A88 88 0 0140.37 136zm149.77 54.14A87.45 87.45 0 01136 215.61v-40.27a47.55 47.55 0 0024.73-12.23A48 48 0 00136 80.66V40c45.52 4.08 80.67 43.28 80 89.25a87.45 87.45 0 01-25.86 60.89z"
  })));
}

export default SvgChartdonut;